<template>
  <BaseInlineSvg
    :id="id"
    :src="svgPath"
    :svgClass="renderSVGClass"
  ></BaseInlineSvg>
</template>

<script>
import BaseInlineSvg from "@/lib/tui/components/display/BaseInlineSvg.vue";

export default {
  name: "BaseIcon",
  components: {
    BaseInlineSvg
  },
  ///////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////
  props: {
    id: {
      type: [String, Number],
      default: "id"
    },
    classState: String,
    isToggle: {
      type: Boolean,
      default: false
    },
    isActive: {
      type: Boolean,
      default: false
    },
    isHover: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isTransparent: {
      type: Boolean,
      default: false
    },
    isReverted: {
      type: Boolean,
      default: false
    },
    state: {
      state: [ String, Boolean ],
      default: false
    },
    svgPath: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ''
    },
    defaultColor: String,
    iconSquare: {
      type: Boolean,
      default: false
    }
  },
  ///////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////
  computed: {
    renderSVGClass: function() {
      if (!this.classState) return;

      // On ne transfert à l'enfant que les status (active, warning etc...)
      let output = "icon";
      let outputArray = this.classState.split(" ");

      for (let i = 0; i < outputArray.length; i++) {
        if (!outputArray[i].endsWith("-trinnov") && !outputArray[i].endsWith("-background"))
          output+= " " + outputArray[i];
      }


      // if (this.defaultColor !== "none") 
      //   output.push(this.defaultColor);

      // if (this.isDisabled)
      //   output.push("disabled");
      // else if (this.isTransparent)
      //   output.push("transparent");
      // else if (this.isActive)
      //   output.push("active");
      // else if (this.isToggle && this.isHover)
      //   output.push("hover");
      // else if (this.isHover)
      //   output.push("active");
      // if (this.isReverted)
      //   output.push('revert');

      return output;
    },
    ///////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////
    renderClassName: function() {
      if(this.className) {
         return this.className;
      }

      return false;
    }
  }
}
</script>

<style lang="scss">
  @import "@/lib/tui/scss/module/baseIcon.scss";
</style>